// extracted by mini-css-extract-plugin
export default {"brandPromo":"LH-z","carousel":"MH-z"};